export const routes = {
  HOME: "/",
  ABOUT: "/about",
  CONTACT: "/contact",
  FIND_LOCATION: "/find-location",
  CANCO_ALL_LOCATIONS: "/canco-all-locations",
  LOGIN: "/login",
  CANCO_CASH_LOYALTY: "/canco-cash-loyalty",
  REGISTER: "/register",
  IN_STORE: "/in-store",
  WORK_WITH_US: "/work-with-us",
  BUSINESS: "/business",
  CANCO_FLEET_CARD: "/canco-xpress-fleet-card",
  CANCO_CONNECT: "/canco-connect",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  BECOME_VENDOR: "/become-vendor",
  BECOME_DEALER: "/become-dealer",
  BECOME_REALTOR: "/become-realtor",
  BECOME_RETAIL_AGENT: "/become-retail-agent",
  BECOME_FLEET_CARD_MEMBER: "/become-fleet-card-member",
  APPLY_CANCO_CONNECT: "/xpress-cardlock-application",
  SURVEY: "/survey",
  // CAREERS: "/careers",
  BLOGS: "/canco-community-care",
  REQUEST_ACOOUNT_DEACTIVATION: "/account-deletion-and-data-removal-policy",
  SUCCESS_ACOOUNT_DEACTIVATION: "/success-account-deletion-request",
  ROAD_TRIP_RULES: "/road-trip",
  SINGLE_BLOG: "/canco-community-care/:blogId",
  CAREERS: "https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=43cc132d-7268-41c5-8f95-9c45fcf64f17&ccId=19000101_000001&type=JS&lang=en_CA&selectedMenuKey=CareerCenter",
  TERMS_CONDITION: "/terms-and-condition",
  PRIVACY_POLICY: "/privacy-policy",
  EMAIL_CONFIRMATION: "/email-confirmation",
  EDIT_USER_PROFILE: "/edit-user-profile",
  CANCO_CONTEST: "/cancocontests",
  SCHOOL_SPIRIT: "/cancocontests/schoolspirit",
  MISSING_POINT: "/missing-points",
  WHOLESALE_BUSINESS: "/wholesale-business",
  MERCHANT_APPLICATION: "/merchant-application",
  THANK_YOU: "thank-you",
  CREDIT_APPLICATION: "/credit-application",
  XPRESS_CARDLOCK_APPLICATION: "/xpress-cardlock-application",
  G_PLAY:
    "https://play.google.com/store/apps/details?id=com.ackroo.canco&hl=en&gl=US",
  APPLE_STORE: "https://apps.apple.com/kh/app/canco-petroleum/id1523902717",
  FACEBOOK: "https://www.facebook.com/cancopetroleum",
  INSTAGRAM: "https://www.instagram.com/cancopetroleum",
  LINKEDIN: "https://www.linkedin.com/company/canco-petroleum/",
};
